import { render, staticRenderFns } from "./BlogTextMod.vue?vue&type=template&id=7c8ec631&scoped=true"
import script from "./BlogTextMod.vue?vue&type=script&lang=js"
export * from "./BlogTextMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8ec631",
  null
  
)

export default component.exports